import {postJsonWithBody} from './fetcher';
import {AnalyzeDocumentsResponse, AnalyzeRequest, Document} from '../analysis/analyze-types';
import {searchPageAttributesMap, SearchPageType} from '../search/search-config';
import {Language} from '../i18nTypes';

export const doAnalyzeRequest = (
    input: string,
    searchPageType: SearchPageType,
    language: Language,
    callback: (res: any) => void
): void => {
    const document: Document = {
        id: input.substr(0, 12),
        content: input,
        language: language === Language.DEFAULT ? null : language,
        title: '',
    };
    const docs = [document];
    const requestBody: AnalyzeRequest = {
        docs: docs,
        ocr: false,
        returnOcrResult: false,
        annotators: null,
        tagTypes: null,
    };
    postJsonWithBody<AnalyzeDocumentsResponse>(
        searchPageAttributesMap[searchPageType].endpoint + '/analyze',
        JSON.stringify(requestBody),
    )
        .then((data: AnalyzeDocumentsResponse) => {
            callback(data.docs[0]);
        })
        .catch((error) => {
            console.error('failed to fetch analyzed document', error);
        });
};
